import {DataSource} from "@/datasources/consulte-grid";
import {BibExemplarModel} from '@/models/biblioteca/bibexemplar/bibexemplar.model';
import BibExemplarService from "@/services/biblioteca/bibexemplar/bibexemplar.service";

export default class BibExemplarDataSource extends DataSource<BibExemplarModel> {
 constructor(pageNumber: number, rowsPerPage: number, rowsPageCount: number, totalRowCount: number, Rows: BibExemplarModel[],
   onLoad?: (rows: any) => void) {
  super(pageNumber, rowsPerPage, rowsPageCount, totalRowCount, new Array<BibExemplarModel>())
  if (onLoad)
   this.setOnLoad(onLoad);
 }

 async load() : Promise<any> {
  const result = ((await BibExemplarService.dadosIndexPaginado(this.pageNumber, this.rowsPerPage, this.filters)).data as any) as DataSource<BibExemplarModel>;
  this.pageNumber = result.pageNumber;
  this.rowsPageCount = result.rowsPageCount;
  this.rowsPerPage = result.rowsPerPage;
  this.rows = result.rows;
  this.sortDataField = result.sortDataField;
  this.sortOrder = result.sortOrder;
  this.totalRowCount = result.totalRowCount;
  this.filters = result.filters;
  return super.load();
 }
}
